export const EDITABLE_REGIMEN_HRS_AGE = 24;
